import { addTemplatePages } from 'common/api/templates';
import showToast from 'common/utils/showToast';

import {
    ADD_TEMPLATE_PAGES,
    ADD_TEMPLATE_PAGES_FAILURE,
    ADD_TEMPLATE_PAGES_SUCCESS,
} from '../actionTypes';
import { editTemplateViewActions } from '../reducer';

export default (customTemplateId, cloneTemplateId, pages, addNewPages) =>
    (dispatch) => {
        const newData = {
            from_template: cloneTemplateId,
            pages,
        };

        dispatch(editTemplateViewActions[ADD_TEMPLATE_PAGES]());

        return addTemplatePages(customTemplateId, newData)
            .then((response) => {
                dispatch(editTemplateViewActions[ADD_TEMPLATE_PAGES_SUCCESS]());
                addNewPages(response.data.pages_template);
                showToast({
                    body: 'Se agregaron nuevas páginas',
                });
            })
            .catch((error) =>
                dispatch(
                    editTemplateViewActions[ADD_TEMPLATE_PAGES_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
